(async () => {
    const { Core } = await importModule('Core');
    const { Plyr } = await importModule('Plyr');

    customElements.define('video-bg', class extends Core {

        elements = {
            player: '[data-player]'
        }

        render() {
            this._initPlayer();
            this.intersectionObserver.observe(this);
        }

        _initPlayer() {
            this.player = new Plyr(this.$player, {
                muted: true,
                controls: false,
                clickToPlay: false,
                fullscreen: false
            });
            this.player.on('ended', () => {
                this.player.restart();
            })
            this.player.on('ready', () => {
                this.player.play();
                this.player.decreaseVolume(100);
            })
        }

        _observer([ entry ]) {
            entry.isIntersecting ? this.player?.play() : this.player?.pause();
        }

        get intersectionObserver() {
            return new IntersectionObserver(this._observer.bind(this));
        }
    })
})();